




























import { defineComponent, toRefs, PropType, computed } from '@vue/composition-api';
import {
  AdgroupFormData,
  FullNormalFormData,
  AcoFormData,
  LandingPageStrategy,
  VerticalCreativeStrategy,
  CreativeConfig,
  CampaignFormData,
  NormalCreative,
  CreateMode,
} from '@tt4b/ttam-enums';
import DynamicLandingSwitch from './index';
import InstantPage from '../instant-page/index';
import { useAdgroupMode } from '@tt4b/ttam-hooks';

const name = 'ttam-creative-dynamic-destination-switch-compose';
export default defineComponent({
  name,
  components: {
    TtamDynamicDestinationSwitch: DynamicLandingSwitch.TtamDynamicDestinationSwitch,
    TtamDynamicDestinationSwitchTips: DynamicLandingSwitch.TtamDynamicDestinationSwitchTips,
    TtamDynamicDestinationErrorTips: DynamicLandingSwitch.TtamDynamicDestinationErrorTips,
  },
  props: {
    createMode: {
      type: String as PropType<CreateMode>,
      default: CreateMode.CREATE,
    },
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    creativeData: {
      type: Object as PropType<FullNormalFormData & AcoFormData>,
      default: () => ({}),
    },
    creativeConfig: {
      type: Object as PropType<CreativeConfig>,
      default: () => ({}),
    },
    normalCreative: {
      type: Object as PropType<NormalCreative>,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const { campaignData, adgroupData, creativeData, creativeConfig, normalCreative, createMode } = toRefs(props);
    const switchVal = computed({
      get: () => creativeData.value.landingPageStrategy === LandingPageStrategy.DLP,
      set: (val: boolean) => {
        const v = val ? LandingPageStrategy.DLP : LandingPageStrategy.DEFAULT;
        emit('input', v);
        emit('change', {
          landingPageStrategy: v,
        });
      },
    });
    const { isEdit } = useAdgroupMode({ createMode });

    const { disabled } = DynamicLandingSwitch.usePropsSwitchDisabled({
      creativeConfig,
    });

    const { visible: showPageError } = InstantPage.usePropsErrorTipVisible({
      campaignData,
      creativeData,
    });

    const tipsVisible = computed(
      () =>
        switchVal.value &&
        showPageError.value &&
        creativeData.value.verticalCreativeStrategy === VerticalCreativeStrategy.UNSET,
    );

    const createPage = () => {
      emit('create-page');
    };

    return {
      name,
      switchVal,
      tipsVisible,
      disabled,
      createPage,
      isEdit,
    };
  },
});
